import './indicator-filter.component.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { HypervisionState } from '@hypervision/hypervision-routing.module';
import { forEach, IChangesObject, IComponentController, IComponentOptions, isDefined } from 'angular';

import { DisplayDeprecatedComponent, MessagingService } from '@contact/upgrade';

import { ISkillViewFilterService } from '../filter.service';
import templateUrl from './indicator-filter.component.ajs.html';

const MODULE_NAME = 'skillViewIndicatorFilter';

class IndicatorFilterCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;

  public filterView: string;
  public onChangeFilterView: Function;

  public viewName: string;
  public currentView: string = 'filterIndicators';
  public indicators: any[];

  constructor(
    private readonly SKILL_METRIC_NAMES,
    private readonly skillFilterHypervision: ISkillViewFilterService,
    private readonly messaging: MessagingService
  ) {
    super();
  }

  $onInit() {
    this.viewName = HypervisionState.SKILL_CUSTOM || '';
    this.indicators = this.SKILL_METRIC_NAMES.map(m => ({ label: m.label, show: true }));

    // filterChanged
    this.messaging
      .forLocal()
      .listen$('filterChanged')
      .pipe(ng1Destroy(this))
      .subscribe((data: any) => {
        if (data !== undefined && data.emitter === 'SkillTableCtrl') {
          let filter = this.skillFilterHypervision.getFilter(this.viewName);
          if (isDefined(filter)) {
            forEach(this.indicators, currentIndicator => {
              if (isDefined(filter.indicators[currentIndicator.label])) {
                currentIndicator.show = filter.indicators[currentIndicator.label];
              }
            });
          }
        }
      });
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }) {
    if (onChangesObj['filterView'] && isDefined(onChangesObj['filterView'].currentValue)) {
      this.filterView = onChangesObj['filterView'].currentValue;
    }
  }

  filterUpdated(indicator) {
    this.skillFilterHypervision.notifyIndicatorChange(this.viewName, indicator.label, indicator.show);
    this.messaging.forLocal().publish('filterChanged', { emitter: 'SkillPersoMetricFilterCtrl' });
  }

  isCurrentFilterView(): boolean {
    return this.filterView === this.currentView;
  }

  changeView() {
    this.onChangeFilterView({ $event: { filterView: this.currentView } });
  }
}

export class IndicatorFilter implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    filterView: '<',
    onChangeFilterView: '&',
  };
  controller = ['SKILL_METRIC_NAMES', 'skillFilterHypervision', 'messaging', IndicatorFilterCtrl];
}

export default MODULE_NAME;
